// extracted by mini-css-extract-plugin
module.exports = {"container":"node-automation_container__1tJNv","title":"node-automation_title__25_og","icon":"node-automation_icon__237OQ"};